import { ca } from '@cian/analytics';

export function trackCpdLandingLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'top_menu',
    label: 'cpd',
  });
}

export function trackCpdLandingDropdownLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_sale',
    action: 'top_menu',
    label: 'cpd',
  });
}
